export default __webpack_public_path__ + "static/media/l22-icon.49e47b9a.webp";